type RailsSortOrder = 'ascend' | 'descend';

const mapSortOrderRails = (sort?: RailsSortOrder) =>
  sort
    ? (
        {
          ascend: 'asc',
          descend: 'desc',
        } as const
      )[sort]
    : undefined;

export const getRailsSortParameters = <T extends string>(data: Record<T, RailsSortOrder | undefined>) => {
  for (const [key, value] of Object.entries(data)) {
    if (value) {
      return {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- Object.entries widens the key to string
        order: key as T,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- The value is present only when it is a sort order
        sort: mapSortOrderRails(value as RailsSortOrder),
      };
    }
  }

  return {};
};
